/**
 * Root of the manual-booking flow: the search page (flight and hotel tabs) and the basket that follows it.
 *
 * Held as a path prefix rather than a list from the route registry so that every step of the flow, including any
 * added later, counts as the same place. Callers pass `location.pathname`.
 */
const MANUAL_BOOKING_ROOT = '/manual-booking';

/**
 * Whether the user is on a page of the manual-booking flow.
 *
 * The basket is the trip being assembled in that flow, not a standing app-wide cart: it is only ever offered while
 * the user is inside the flow, and is dropped the moment they go anywhere else.
 */
export function isManualBookingPath(pathname: string): boolean {
  return pathname === MANUAL_BOOKING_ROOT || pathname.startsWith(`${MANUAL_BOOKING_ROOT}/`);
}
